import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  /**
   * paylink-library serialises LocalDateTime as "yyyy-MM-dd HH:mm:ss.SSS" — not ISO-8601:
   * `new Date()` accepts it in Chromium but returns Invalid Date in WebKit. Parse the parts
   * ourselves; java.util.Date fields still arrive as epoch millis. One copy for every screen,
   * so a serializer change cannot leave two PDPL pages disagreeing on a deadline.
   */
  public parseApiDate(value: number | string | null | undefined): Date | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }
    if (typeof value === 'number') {
      const fromMillis = new Date(value);
      return isNaN(fromMillis.getTime()) ? null : fromMillis;
    }
    const m = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})/.exec(value);
    if (m) {
      return new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +m[6]);
    }
    const parsed = new Date(value);
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  public updateCustomProperty(merchantInfo, element) {
    if (merchantInfo.payStoreSettings) {
      let primaryColor = merchantInfo.payStoreSettings.primaryColor;
      let secondaryColor = merchantInfo.payStoreSettings.secondaryColor;
      let footerColor = merchantInfo.payStoreSettings.footerColor;
      let footerBackgroundColor = merchantInfo.payStoreSettings.footerBackgroundColor;

      if (primaryColor) {
        element.nativeElement.style.setProperty('--primaryColor', primaryColor);
      }
      if (secondaryColor) {
        element.nativeElement.style.setProperty('--secondaryColor', secondaryColor);
      }
      if (footerColor) {
        element.nativeElement.style.setProperty('--footerColor', footerColor);
      }
      if (footerBackgroundColor) {
        element.nativeElement.style.setProperty('--footerBackgroundColor', footerColor);
      }
    }
  }

  processResponse(data) {
    if (typeof data === 'string') {
      try {
        let jsonObject = JSON.parse(data);
        // Now `jsonObject` is the JavaScript object you can work with
        console.log(jsonObject);
        return jsonObject;
        // Perform your operations with jsonObject
      } catch (e) {
        console.error('Error parsing JSON string:', e);
        // Handle error or invalid JSON string
        return data;
      }
    } else {
      // Handle case where data is not a string
      console.log('Received data is not a string:', data);
      return data;
    }
  }

  public isJsonString(data): boolean {
    try {
      JSON.parse(data);
      return true;
    } catch (e) {
      return false;
    }
  }
}
